<template>
  <div class="home">
    <div class="min-container">
      <div class="banner">
        <swiper :options="swiperBannerOption">
          <swiper-slide
            v-for="(item, index) in banner"
            :key="index"
            style="height: 410px;"
          >
            <div @click.prevent="toBlogItem(item.articleId)">
              <div
                :style="item.style"
                class="banner_img"
                aria-label="banner_img"
              />
              <div class="banner_content">
                <div class="banner_blog">
                  <h2>{{ item.title }}</h2>
                  <p>{{ item.subtitle }}</p>
                </div>
              </div>
            </div>
          </swiper-slide>
          <div
            v-show="banner.length > 1"
            slot="button-prev"
            class="swiper-button-prev"
          />
          <div
            v-show="banner.length > 1"
            slot="button-next"
            class="swiper-button-next"
          />
        </swiper>
      </div>
    </div>
    <div class="middle min-container">
      <div>
        <el-tabs
          v-if="showTab"
          v-model="tabId"
        >
          <el-tab-pane
            v-for="tab in tabs"
            :key="tab.id"
            :label="tab.name"
            :name="tab.id"
            class="first"
          >
            <div class="report_con container center">
              <div class="big_content">
                <div class="top_tab">
                  <div class="tab-image">
                    <div
                      v-for="(item, index) in formatData(blogList[tabId + 'page'], 0, 1)"
                      :key="index"
                      class="jumpUrl"
                      @click="toBlogItem(item.id)"
                    >
                      <img
                        width="100%"
                        height="447px"
                        :src="item.image"
                        class="big_img"
                        alt
                      >
                      <div class="jump_cont">
                        <p class="jump_p">
                          {{ item.title }}
                        </p>
                        <div class="jump_release">
                          <span>{{ item.release }}</span>
                          <img
                            v-if="item.from_channel"
                            height="38px"
                            :src="'/official/static/img/home/channel/' + item.from_channel + '.png'"
                            alt
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="tab_cont">
                    <div class="tab_p">
                      <div
                        v-for="(item, index) in formatData(blogList[tabId + 'page'], 1, 5)"
                        :key="index"
                        class="jumpUrl"
                        @click="toBlogItem(item.id)"
                      >
                        <!-- <img
                          :src="item.image"
                          width="157px"
                          height="90px"
                          alt
                        >-->
                        <div class="jump_cont jump_cont_hl">
                          <p class="jump_p">
                            {{ item.title }}
                          </p>
                          <div class="jump_release">
                            <span>{{ item.release }}</span>
                            <img
                              v-if="item.from_channel"
                              height="25px"
                              :src="'/official/static/img/home/channel/' + item.from_channel + '.png'"
                              alt
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <h2
                v-if="blogList[tabId + 'page'] && blogList[tabId + 'page'].length > 5"
                class="home-color"
              >
                {{ $t('common.p38') }}
              </h2>
              <div class="right">
                <div
                  v-for="item in formatData(blogList[tabId + 'page'], 5, 100)"
                  :key="item.id"
                  class="img_item"
                >
                  <img
                    :src="item.image"
                    height="210px"
                    alt
                    class="top_img"
                    @click="toBlogItem(item.id)"
                  >
                  <div class="img_content">
                    <p
                      class="p1 home-color"
                      @click="toBlogItem(item.id)"
                    >
                      {{ item.title }}
                    </p>
                    <div class="jump_release">
                      <span>{{ item.release }}</span>
                      <img
                        v-if="item.from_channel"
                        height="25px"
                        :src="'/official/static/img/home/channel/' + item.from_channel + '.png'"
                        alt
                      >
                    </div>
                    <!-- <p class="p2">
                      {{ item.subtitle }}
                    </p>-->
                  </div>
                </div>
                <!-- <el-pagination
                  class="blog-pagination"
                  background
                  size="large"
                  layout="prev, pager, next"
                  :page-size="pageSize"
                  :hide-on-single-page="true"
                  :total="blogList[tabId].length"
                  @current-change="currentChange($event, tabId)"
                />-->
              </div>
              <!-- <div class="left">
                <div
                  class="left_item bg-color home-color"
                  style="font-weight: bold;"
                >
                  {{ $t('common.p82') }}
                </div>
                <div
                  v-for="(item, index) in popularList"
                  :key="index"
                  class="left_item bg-color home-p-color"
                  @click="toBlogItem(item.id)"
                >
                  <div class="item_content">
                    <p class="p1">
                      {{ item.title }}
                    </p>
                    <p class="p2">
                      <span>{{ item.release }}</span>
                    </p>
                  </div>
                </div>
              </div>-->
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { getBlogBanner, getBlogTab, getBlogArticle } from "@/api/official";

export default {
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      swiperBannerOption: {
        autoplay: {
          delay: 5000,
          disableOnInteraction: true
        },
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      banner: [],
      // activeName: 'Live',
      tabs: [],
      tabId: "",
      blogList: {},
      popularList: [],
      showTab: false,
      pageSize: 100
    };
  },
  computed: {
    name() {
      return this.data;
    }
  },
  created() {
    this.$store.commit("changeTab", "/blog");
    this.initData();
  },
  mounted() {
    document
      .querySelector("#app")
      .scrollIntoView({ block: "start", behavior: "smooth" });
  },
  methods: {
    formatData(data, left, right) {
      if (data && data.length) {
        return data.slice(left, right);
      }
      return [];
    },
    initData() {
      getBlogBanner()
        .then(res => {
          this.banner = res.data.list.map(v => {
            return {
              style: {
                backgroundImage: "url(" + v.image + ")"
              },
              ...v,
              ...v.article[this.$i18n.locale]
            };
          });
        })
        .catch(err => {
          console.log(err);
        });

      getBlogTab()
        .then(res => {
          this.tabs = res.data.list.map((v, index) => {
            if (index === 0) {
              this.tabId = v.id + "";
            }
            if (this.$route.query.tab) {
              this.tabId = this.$route.query.tab + "";
            }
            this.initBlogList(v.id);
            return {
              name: v.lang[this.$i18n.locale],
              id: v.id + ""
            };
          });
        })
        .catch(err => {
          console.log(err);
        });

      // getBlogArticle({ isFavorite: 1 })
      //   .then(res => {
      //     console.log(res)

      //     this.popularList = res.data.list.map(v => {
      //       return { id: v.id, ...v.article[this.$i18n.locale], release: v.release }
      //     })
      //   })
      //   .catch(err => {
      //     console.log(err)
      //   })
    },
    initBlogList(id) {
      id = "" + id;
      getBlogArticle({ blogTabId: id })
        .then(res => {
          const channelTypeMap = {
            '1' : 'cardplayer',
            '2' : 'poker_blog',
            '3' : 'pokernews',
            '4' : 'super_poker',
            '5' : 'yahoo',
          }

          this.blogList[id] = res.data.list.map(v => {
            return {
              id: v.id,
              ...v.article[this.$i18n.locale],
              image: v.pcImage,
              release: v.release,
              from_channel: (v.from_channel ? channelTypeMap[v.from_channel] : '')
            };
          });
          let newArray = this.blogList[id].filter((v, ind) => {
            return ind < this.pageSize;
          });

          let parm = id + "page";
          this.$set(this.blogList, parm, newArray);

          if (this.tabId === id) {
            this.showTab = true;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    toBlogItem(item) {
      if (item.substring(0, 4) === 'http') {
        window.open(item);
      } else {
        window.open("/blog/" + item);
      }
    },
    currentChange(page, id) {
      this.blogList[id + "page"] = this.blogList[id].filter((v, ind) => {
        return ind >= (page - 1) * this.pageSize && ind < page * this.pageSize;
      });
      document
        .querySelector(".home .middle")
        .scrollIntoView({ block: "start", behavior: "smooth" });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.home {
  position: relative;
  padding: 0;
  .banner {
    position: relative;
    height: 410px;
    z-index: 1;
    background-color: #000;
    min-width: 1200px;
    .banner_img {
      display: block;
      width: 100%;
      height: 410px;
      cursor: pointer;
      background-position: center center;
      background-repeat: no-repeat;
    }
    .banner_bg {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0px;
      left: 0px;
      background-size: 100% auto;
      background-repeat: no-repeat;
      z-index: -1;
      opacity: 0.2;
    }
    .banner_content {
      position: absolute;
      width: 100%;
      bottom: 0px;
      background-color: rgba(0, 0, 0, 0.8);
      cursor: pointer;
      .banner_blog {
        padding: 4px 0px 10px 0px;
        width: 1180px;
        margin: 0 auto;
        h2 {
          margin: 0px 0px 4px 0px;
          color: #1f9d56;
        }
      }
    }
    /deep/.el-carousel__arrow {
      font-size: 30px;
    }
    .swiper-button-prev {
      background: url("/official/static/img/home/arrow_l.png") center center;
      background-size: 100%;
    }
    .swiper-button-next {
      background: url("/official/static/img/home/arrow_r.png") center center;
      background-size: 100%;
    }
  }
  .top {
    position: relative;
    width: 100%;
    height: 57px;
    .top_title {
      font-size: 18px;
      color: #fff;
      a {
        cursor: pointer;
        line-height: 57px;
        color: #767676;
        margin: 0 20px;
      }
      a:nth-child(1) {
        margin-left: 0px;
      }
      .highlight {
        color: #1f9d56;
      }
    }
  }
  .middle {
    color: #fff;
    position: relative;
    padding: 0px 0px 9px 0px;
    min-height: 600px;
    /deep/.el-tabs__header {
      margin-bottom: 0px;
    }
    /deep/.el-tabs__item {
      color: #cccccc;
      font-size: 18px;
    }
    /deep/.el-tabs__nav-wrap.is-top {
      // display: inline-block;
      width: auto;
      padding-top: 12px;
      background-color: #000;
    }
    /deep/.el-tabs__nav-scroll {
      width: 1200px;
      margin: 0 auto;
    }
    /deep/.el-tabs__nav.is-top {
      transform: translateX(0%) !important;
      padding: 0 10px;
    }
    /deep/.el-tabs__nav-wrap::after {
      background-color: #cccccc;
      height: 0px;
    }
    /deep/.el-tabs__item.is-top.is-active {
      color: #1f9d56;
      // font-weight: bold;
    }
    /deep/.el-tabs__active-bar {
      background-color: #1f9d56;
      padding-right: 20px;
      height: 0px;
      margin-bottom: -1px;
      border-bottom: 5px solid #1f9d56;
    }
    /deep/.el-tabs__item {
      height: 50px;
    }
    .first {
      .report_con {
        // display: flex;
        // justify-content: space-around;
        // align-items: flex-start;
        margin-top: 65px;
        min-height: 600px;
        text-align: left;
        .big_content {
          margin-bottom: 40px;
          .top_tab {
            position: relative;
            margin: 0 auto;
            top: 10px;
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            text-align: left;
            .tab-image {
              position: relative;
              display: block;
              width: 795px;
              padding: 0px;
              margin: 0px;
              .jumpUrl {
                display: block;
                color: #828282;
                width: 100%;
                background-color: #ffffff;
                overflow: hidden;
                cursor: pointer;
                img {
                  display: block;
                }
                .jump_cont {
                  padding: 5px 22px;
                  width: 751px;
                  height: 64px;
                  position: absolute;
                  left: 0px;
                  bottom: 0px;
                  background-color: rgba(0, 0, 0, 0.8);
                  display: flex;
                  flex-direction: column;
                  justify-content: space-around;
                  .jump_p {
                    text-overflow: ellipsis;
                    color: #ffffff;
                    font-size: 16px;
                    line-height: 22px;
                  }
                  .jump_release {
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-end;
                    span {
                      color: #b8b8b8;
                      font-size: 14px;
                      line-height: 14px;
                      margin-bottom: -1px;
                    }
                  }
                }
              }
              .jumpUrl .big_img {
                -o-transition: all cubic-bezier(0.165, 0.84, 0.44, 1) 0.3s;
                transition: all cubic-bezier(0.165, 0.84, 0.44, 1) 0.3s;
                -webkit-transform: scale(1);
                -ms-transform: scale(1);
                transform: scale(1);
              }
              .jumpUrl:hover .big_img {
                -webkit-transform: scale(1.05);
                -ms-transform: scale(1.05);
                transform: scale(1.05);
              }
            }
            .tab_cont {
              width: 370px;
              margin-left: 10px;

              .el-divider--horizontal {
                margin: 0px 0px 15px 0px;
              }
              .el-divider {
                background-color: #828282;
              }
              .tab_p {
                .jumpUrl {
                  display: flex;
                  color: #828282;
                  line-height: 30px;
                  font-size: 16px;
                  width: 370px;
                  background-color: #ffffff;
                  justify-content: space-between;
                  align-items: flex-start;
                  margin-bottom: 11px;
                  cursor: pointer;
                  padding-bottom: 13px;
                  border-bottom: 1px solid #d9d9d9;
                  &:hover {
                    color: #1f9d56;
                  }
                  .jump_cont {
                    width: 370px;
                    height: 90px;
                    padding-right: 6px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    .jump_p {
                      text-overflow: ellipsis;
                      color: #272727;
                      font-size: 16px;
                      line-height: 22px;
                    }
                    .jump_release {
                      display: flex;
                      justify-content: space-between;
                      align-items: flex-end;
                      span {
                        color: #7d7d7d;
                        font-size: 14px;
                        line-height: 14px;
                        margin-bottom: -1px;
                      }
                    }
                  }
                  .jump_cont.jump_cont_hl:hover {
                    .jump_p {
                      color: #1f9d56;
                    }
                  }
                }
                .jumpUrl.highlight {
                  color: #1f9d56;
                }
              }
            }
          }
        }
        .left {
          position: relative;
          display: inline-block;
          .left_item:nth-child(n + 2) {
            cursor: pointer;
          }
          .left_item {
            position: relative;
            width: 210px;
            margin-bottom: 1px;
            padding: 15px 15px;
            .item_content {
              position: relative;
              z-index: 1;
            }
            .p1 {
              font-size: 14px;
              text-align: left;
            }
            .p2 {
              font-size: 12px;
              color: #7b7b7b;
              text-align: right;
              margin-top: 2px;
            }
          }
          .highlight {
            background-color: #58b26d;
          }
          .left_item::after {
            position: absolute;
            content: "";
            display: block;
            top: 0px;
            left: 0px;
            width: 0;
            height: 100%;
            background-color: #58b26d;
            transition: all 0.6s ease 0s;
          }
          .left_item:nth-child(n + 2):hover::after {
            width: 100%;
          }
          .left_item:hover {
            .p1,
            .p2 {
              color: #fff;
            }
          }
          .icon {
            display: inline-block;
            margin-top: 15px;
            a {
              margin: 0 10px;
              display: inline-block;
              background-size: 100%;
              background-repeat: no-repeat;
              background-position: center center;
              width: 12px;
              height: 26px;
              vertical-align: middle;
            }
            .facebook-img {
              background-image: url(/official/static/img/blog/f_g.png);
              // &:hover {
              //   background-image: url(/official/static/img/blog/f_g.png);
              // }
            }
            .instagram-img {
              width: 20px;
              background-image: url(/official/static/img/blog/in_g.png);
              // &:hover {
              //   background-image: url(/official/static/img/blog/in_g.png);
              // }
            }
            .twitter-img {
              width: 22px;
              background-image: url(/official/static/img/blog/t_g.png);
              background-position: center bottom;
              // &:hover {
              //   background-image: url(/official/static/img/blog/t_g.png);
              // }
            }
            /deep/span {
              display: inline-block;
              &:focus {
                outline: none;
              }
            }
            /deep/img {
              margin: 10px 10px;
              display: inline-block;
              cursor: pointer;
            }
          }
        }
        .right {
          position: relative;
          width: 100%;
          // display: inline-block;
          padding-bottom: 60px;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          flex-wrap: wrap;
          .img_item {
            position: relative;
            width: 373px;
            // height: 210px;
            background-color: #f4f4f4;
            margin-bottom: 30px;
            overflow: hidden;
            .top_img {
              width: 100%;
              display: block;
              cursor: pointer;
            }
            .img_content {
              position: relative;
              // width: 100%;
              left: 0px;
              bottom: 0px;
              background-color: #f4f4f4;
              padding: 17px 0px;
              text-align: left;
              width: 100%;
              min-height: 72px;
              .p1 {
                font-size: 16px;
                line-height: 22px;
                min-height: 44px;
                // font-weight: bold;
                margin-bottom: 8px;
                padding: 0px 14px;
                color: #272727;
                cursor: pointer;
                &:hover {
                  color: #1f9d56;
                }
              }
              .p2 {
                font-size: 14px;
                line-height: 18px;
                padding: 0px 21px;
                color: #7d7d7d;
              }
              .jump_release {
                display: flex;
                justify-content: space-between;
                align-items: flex-end;
                padding: 0px 14px;
                span {
                  color: #7d7d7d;
                  font-size: 14px;
                  line-height: 14px;
                  margin-bottom: -1px;
                }
              }
            }
          }
          .img_item .top_img {
            -o-transition: all cubic-bezier(0.165, 0.84, 0.44, 1) 0.3s;
            transition: all cubic-bezier(0.165, 0.84, 0.44, 1) 0.3s;
            -webkit-transform: scale(1);
            -ms-transform: scale(1);
            transform: scale(1);
          }
          .img_item .top_img:hover {
            -webkit-transform: scale(1.05);
            -ms-transform: scale(1.05);
            transform: scale(1.05);
          }
          .blog-pagination {
            transform: scale(1.3);
          }
        }
        .right:after {
          content: "";
          width: 30%;
          border: 1px solid transparent;
        }
      }
    }
  }
}
</style>
